<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-close-24`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.92762 4.93029C5.22051 4.6374 5.69538 4.6374 5.98828 4.93029L11.9985 10.9405L18.0104 4.92865C18.3033 4.63576 18.7782 4.63576 19.071 4.92865C19.3639 5.22155 19.3639 5.69642 19.071 5.98931L13.0592 12.0012L19.0698 18.0118C19.3626 18.3047 19.3626 18.7795 19.0698 19.0724C18.7769 19.3653 18.302 19.3653 18.0091 19.0724L11.9985 13.0618L5.98957 19.0708C5.69668 19.3637 5.2218 19.3637 4.92891 19.0708C4.63602 18.7779 4.63602 18.303 4.92891 18.0101L10.9379 12.0012L4.92762 5.99095C4.63472 5.69806 4.63472 5.22319 4.92762 4.93029Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineClose24',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
